/**
 * Extracts the YouTube Video ID from various YouTube URL formats.
 * @param {string | null | undefined} url - The YouTube URL.
 * @returns {string | null} The video ID or null if not found or invalid URL.
 */
export const getYouTubeVideoId = (url) => {
  if (!url) return null;
  try {
    const urlObj = new URL(url);
    if (urlObj.hostname === 'youtu.be') {
      // Handles short URLs like youtu.be/VIDEO_ID
      return urlObj.pathname.slice(1);
    }
    if (urlObj.hostname.includes('youtube.com')) {
      // Handles standard URLs like youtube.com/watch?v=VIDEO_ID
      const params = new URLSearchParams(urlObj.search);
      const videoId = params.get('v');
      if (videoId) return videoId;

      // Handles embed URLs like youtube.com/embed/VIDEO_ID
      if (urlObj.pathname.startsWith('/embed/')) {
        return urlObj.pathname.split('/')[2];
      }
    }
  } catch (e) {
    console.error("Error parsing YouTube URL:", url, e);
  }
  // Fallback regex for cases the URL object might miss (less robust)
  const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  if (match && match[1]) {
    return match[1];
  }

  console.warn("Could not extract YouTube video ID from URL:", url);
  return null;
};
